import React from 'react';
import { Link } from 'react-router';

function linkToSubpage(link, setDish, dish) {
	setDish(dish);
	console.log('Still done!')
}

const WarningTags = ({ warningList }) => {
	if ( warningList.length ) {
		return (
			<div>
				{warningList.map((warning, i) => (
					<div key={i} className="tag tag--red pull-left">
						{warning}
					</div>
				))}
			</div>
		)
	} else {
		return <div/>
	}
}

const Benefits = ({ benefits }) => {
	let ben = benefits.slice(0, 2)
	console.log(benefits.length)
	const isCut = benefits.length > 2;
	return (
		<ul className="unformated-list" style={{marginBottom: 0}}>
			{ben.map((benefit) => (
				<li
					key={benefit}
					className="main-color">
					<span className="single-line tag tag--green">
					  {benefit}
					</span>
				</li>
			))}
			{isCut &&
				<span className="main-color benefits__dots">...</span>
			}
		</ul>
  )
}

const DishesSingle = ({
	image,
	name,
	link,
	dish,
	setDish,
	warningList,
	order,
	benefits,
}) => (
	<Link 
		to={"app/detail/" + dish.image}
		style={{order: order}}
		onClick={() => linkToSubpage(link, setDish, dish)}>
		<div className="single-dish">
			<img src={image} alt={'Image -' + name} />
			<div className="dish-list__description">
				<p className="single-line margin0">
					{name}
				</p>
				<WarningTags warningList={warningList} />
				{!warningList.length && benefits &&
					<Benefits benefits={benefits} />
				}
			</div>
			<div className="clearfix" />
		</div>
		<div className="clearfix" />
	</Link>
)

export default DishesSingle;


// WEBPACK FOOTER //
// ./src/dishes/DishesSingle.js